import {NEW_API_URL} from '../config/api';
import axios from 'axios';

let isRefreshing = false;
let refreshQueue: Array<{
  resolve: (t: string) => void;
  reject: (e: any) => void;
}> = [];

export const getAccessToken = (): string | null => {
  return localStorage.getItem('accessToken');
};

export const refreshAccessToken = async (): Promise<string> => {
  if (isRefreshing) {
    return await new Promise((resolve, reject) => {
      refreshQueue.push({resolve, reject});
    });
  }

  isRefreshing = true;
  const refreshToken = localStorage.getItem('refreshToken');

  try {
    const response = await axios.post(
      `${NEW_API_URL}/auth/employee-refresh`,
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`
        }
      }
    );
    // The API wraps its answer: `{success, message, data: {access_token, …}}`.
    const tokens = response?.data?.data ?? response?.data;
    const newAccessToken = tokens?.access_token;
    if (!newAccessToken) {
      throw new Error('Token refresh response is missing access_token');
    }
    localStorage.setItem('accessToken', newAccessToken);
    if (tokens?.refresh_token) {
      localStorage.setItem('refreshToken', tokens.refresh_token);
    }

    refreshQueue.forEach((q) => q.resolve(newAccessToken));
    refreshQueue = [];
    return newAccessToken;
  } catch (err) {
    rejectQueue(err);
    throw err;
  } finally {
    isRefreshing = false;
  }
};

const rejectQueue = (err: any) => {
  refreshQueue.forEach((q) => q.reject(err));
  refreshQueue = [];
  throw err;
};
